<template>
	<div class="drawer-container">
		<el-form ref="form" :model="form">
			<div>
				<h3 class="drawer-title">系统布局配置</h3>
				<div class="drawer-item">
					<span>主题颜色</span>
					<theme-picker class="themeColor" @change="themeChange()" />
				</div>
				<!-- <div class="drawer-item">
					<span>开启 Tags-Views</span>
					<el-switch v-model="tagsView" class="drawer-switch" />
				</div>
				<div class="drawer-item">
					<span>固定 Header</span>
					<el-switch v-model="fixedHeader" class="drawer-switch" />
				</div>
				<div class="drawer-item">
					<span>显示 Logo</span>
					<el-switch v-model="sidebarLogo" class="drawer-switch" />
				</div> -->
			</div>

			<div class="mt20">
        <h3 class="drawer-title">首页布局配置</h3>
       <div class="innerbox" style="height: 60vh; overflow: auto">
        <div class="drawer-item" v-hasPermi="['ywpx:index:project']">
          <el-form-item label="项目管理">
            <el-switch v-model="form.projectShow" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
        <div class="drawer-item" v-hasPermi="['ywpx:index:settlement']">
          <el-form-item label="结算管理">
            <el-switch v-model="form.settlementShow" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
        <div class="drawer-item" v-hasPermi="['ywpx:index:undertake']">
          <el-form-item label="机构管理">
            <el-switch v-model="form.unitShow" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
        <div class="drawer-item" v-hasPermi="['ywpx:index:reports']">
          <el-form-item label="报表中心">
            <el-switch v-model="form.reportShow" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
<!--				<div class="drawer-item" v-hasPermi="['ywpx:index:schedule']">-->
<!--					<el-form-item label="日程">-->
<!--						<el-switch v-model="form.scheduleShow" class="drawer-switch"></el-switch>-->
<!--					</el-form-item>-->
<!--				</div>-->
        <div class="drawer-item" v-hasPermi="['ywpx:index:enroll']">
          <el-form-item label="招生待办">
            <el-switch v-model="form.recruitShow" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
        <div class="drawer-item" v-hasPermi="['ywpx:index:trip']">
          <el-form-item label="行程待办">
            <el-switch v-model="form.ItineraryShow" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
        <div class="drawer-item" v-hasPermi="['ywpx:index:ticketing']">
          <el-form-item label="票务待办">
            <el-switch v-model="form.ticketingShow" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
        <div class="drawer-item" v-hasPermi="['ywpx:index:works']">
          <el-form-item label="项目待办">
            <el-switch v-model="form.worksShow" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
				<div class="drawer-item" v-hasPermi="['ywpx:index:news']">
					<el-form-item label="公告中心">
						<el-switch v-model="form.newsShow" class="drawer-switch"></el-switch>
					</el-form-item>
				</div>
        <div class="drawer-item" v-hasPermi="['ywpx:index:topTenProjectNumForUndertake']">
          <el-form-item label="培训项目数前十承办单位"  >
            <el-switch v-model="form.topTenProjectNumForUndertake" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
        <div class="drawer-item" v-hasPermi="['ywpx:index:topTenStuNumForUndertake']">
          <el-form-item label="培训人数前十承办单位"  >
            <el-switch v-model="form.topTenStuNumForUndertake" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
         <div class="drawer-item" v-hasPermi="['ywpx:index:topTenStuNumForEducation']">
           <el-form-item label="培训人数前十的学历项目"  >
             <el-switch v-model="form.topTenStuNumForEducation" class="drawer-switch"></el-switch>
           </el-form-item>
         </div>
        <div class="drawer-item"  v-hasPermi="['ywpx:index:getStusForCharts']">
          <el-form-item label="学员统计">
            <el-switch v-model="form.pieShow" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
        <div class="drawer-item" v-hasPermi="['ywpx:index:statisticStuNumByContinent']">
          <el-form-item label="按洲统计培训人数"  >
            <el-switch v-model="form.statisticStuNumByContinent" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
        <div class="drawer-item" v-hasPermi="['ywpx:index:statisticStuNumByDomain']">
          <el-form-item label="按领域统计培训人数"  >
            <el-switch v-model="form.statisticStuNumByDomain" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
        <div class="drawer-item"  v-hasPermi="['ywpx:index:topTenStuNumForProject']">
          <el-form-item label="培训人数前十项目" >
            <el-switch v-model="form.topTenStuNumForProject" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
        <div class="drawer-item" v-hasPermi="['ywpx:index:signUp']">
          <el-form-item label="培训人数">
            <el-switch v-model="form.signUpShow" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
        <div class="drawer-item" v-hasPermi="['ywpx:index:bar']">
          <el-form-item label="已办项目数" >
            <el-switch v-model="form.barShow" class="drawer-switch"></el-switch>
          </el-form-item>
        </div>
				<div class="drawer-item" v-hasPermi="['ywpx:index:feedback']">
					<el-form-item label="意见反馈" >
						<el-switch v-model="form.feedbackShow" class="drawer-switch"></el-switch>
					</el-form-item>
				</div>
        </div>
			</div>
			<div class="el-dialog__footer">
				<div class="dialog-footer">
 					<button type="button" class="el-button el-button--primary el-button--medium" @click="submitConfig()"><span>确 定</span></button>
					<button type="button" class="el-button el-button--default el-button--medium" @click="setting = false"><span>取 消</span></button>
				</div>
			</div>
		</el-form>
	</div>
</template>

<script>
	import ThemePicker from '@/components/ThemePicker';
	import { changeSysConfig } from "@/api/system/user";
	import { getInfo } from '@/api/login'
	import {isStrEmpty,praseStrEmpty} from "@/utils/gft";


	export default {
		components: {
			ThemePicker
		},
		data() {
			return {
        activeNames: ["1"],
				form: {
					projectShow: false,
					settlementShow: false,
					unitShow: false,
					reportShow: false,
					panelShow: false,
					scheduleShow: false,
					worksShow: false,
					recruitShow: false,
					ItineraryShow: false,
					ticketingShow: false,
					newsShow: false,
					signUpShow: false,
					pieShow: false,
					barShow: false,
          topTenStuNumForUndertake: false,
          topTenStuNumForEducation: false,
          topTenProjectNumForUndertake:false,
          statisticStuNumByContinent:false,
          statisticStuNumByDomain:false,
          topTenStuNumForProject:false,
					feedbackShow: false
				}
			}
		},
		created() {
			this.initInfo();
		},
		// 是一个计算属性,类似于过滤器,对绑定到view的数据进行处理
		computed: {
			fixedHeader: {
				get() {
					return this.$store.state.settings.fixedHeader
				},
				set(val) {
					this.$store.dispatch('settings/changeSetting', {
						key: 'fixedHeader',
						value: val
					})
				}
			},
			tagsView: {
				get() {
					return this.$store.state.settings.tagsView
				},
				set(val) {
					this.$store.dispatch('settings/changeSetting', {
						key: 'tagsView',
						value: val
					})
				}
			},
			sidebarLogo: {
				get() {
					return this.$store.state.settings.sidebarLogo
				},
				set(val) {
					this.$store.dispatch('settings/changeSetting', {
						key: 'sidebarLogo',
						value: val
					})
				}
			},
			setting: {
				get() {
					return this.$store.state.settings.showSettings
				},
				set(val) {
					this.$store.dispatch('settings/changeSetting', {
						key: 'showSettings',
						value: val
					})
				}
			}
		},
		methods: {
			reset(){
				this.form = {
					projectShow: true,
					settlementShow: true,
					unitShow: true,
					reportShow: true,
					panelShow: true,
					scheduleShow: true,
					worksShow: true,
					recruitShow: true,
					ItineraryShow: true,
					ticketingShow: true,
					newsShow: true,
					signUpShow: true,
					pieShow: true,
					barShow: true,
          topTenStuNumForUndertake: true,
          topTenStuNumForEducation:true,
          topTenProjectNumForUndertake:true,
          statisticStuNumByContinent:true,
          statisticStuNumByDomain:true,
          topTenStuNumForProject:false,
					feedbackShow: true
				};
				this.resetForm("form");

			},
      handleChange(val) {
        console.log(val);
      },
			// 初始化基本信息
			initInfo(){
				//获取用户详细信息
				getInfo().then(response=>{
					if(isStrEmpty(response.user.sysConfig)){
						this.reset();
					}else{
						this.form = JSON.parse(response.user.sysConfig);
					}
				})
			},
			themeChange(val) {
				this.$store.dispatch('settings/changeSetting', {
					key: 'theme',
					value: val
				})
			},
			// 用户配置修改接口
			submitConfig(){
				var that = this;
				getInfo().then(response=>{
					this.userId = response.user.userId;
					changeSysConfig(this.userId, JSON.stringify(that.form)).then(response=>{
						// console.log(response.data);
						this.msgSuccess("修改成功");
						window.location.href ="/index";
					})
				})
			},

		}
	}
</script>

<style lang="scss" scoped>
	.themeColor {
		float: right;
		height: 26px;
		margin: -3px 8px 0 0;
	}
	.drawer-container {
		padding: 24px;
		font-size: 14px;
		line-height: 1.5;
		word-wrap: break-word;

		.drawer-title {
			margin-bottom: 12px;
			color: rgba(0, 0, 0, .85);
			font-size: 14px;
			line-height: 22px;
		}
		.drawer-item {
			color: rgba(0, 0, 0, .65);
			font-size: 14px;
			padding: 10px 0;
      overflow: auto;
		}
		.drawer-switch {
			float: right
		}
		.el-form-item {
		    margin-bottom: 0;
		}
		.dialog-footer {
		    margin-top: 20px;
		}
	}

  /*滚动条样式*/
  .innerbox::-webkit-scrollbar {/*滚动条整体样式*/
    display: none;
  }

</style>
